import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage, auth } from "../firebase";
import { X } from "lucide-react";

export default function UserProfilePopup({ onClose }) {
  const [userData, setUserData] = useState(null);
  const [newName, setNewName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [avatarFile, setAvatarFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  const currentUser = auth.currentUser;

  // Lấy dữ liệu user từ Firestore
  useEffect(() => {
    const fetchUser = async () => {
      if (currentUser) {
        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserData(data);
          setNewName(data.name || "");
          setNewEmail(data.email || "");
        }
      }
    };
    fetchUser();
  }, [currentUser]);

  // Xử lý upload avatar
  const handleAvatarChange = (e) => {
    if (e.target.files[0]) {
      setAvatarFile(e.target.files[0]);
    }
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  // Lưu thông tin
  const handleSave = async () => {
    if (!validateEmail(newEmail)) {
      setEmailError("Email không hợp lệ");
      return;
    }
    setEmailError("");
    setLoading(true);

    try {
      let avatarUrl = userData.avatarUrl || "";

      if (avatarFile) {
        const avatarRef = ref(storage, `avatars/${currentUser.uid}`);
        await uploadBytes(avatarRef, avatarFile);
        avatarUrl = await getDownloadURL(avatarRef);
      }

      const docRef = doc(db, "users", currentUser.uid);
      await updateDoc(docRef, {
        name: newName,
        email: newEmail,
        avatarUrl: avatarUrl
      });

      alert("Cập nhật thông tin thành công!");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Lỗi khi lưu thông tin!");
    }
    setLoading(false);
  };

  if (!userData) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 relative shadow-lg">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-vietnam-primary"
        >
          <X size={20} />
        </button>

        {/* Avatar */}
        <div className="flex flex-col items-center mb-4">
          <img
            src={avatarFile ? URL.createObjectURL(avatarFile) : userData.avatarUrl || "https://ui-avatars.com/api/?name=User"}
            alt="avatar"
            className="w-24 h-24 rounded-full object-cover border"
          />
          <label className="mt-2 text-sm cursor-pointer text-vietnam-primary hover:underline">
            Đổi ảnh
            <input type="file" className="hidden" onChange={handleAvatarChange} />
          </label>
        </div>

        {/* Name */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Tên</label>
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="w-full border rounded px-3 py-2 text-sm"
          />
        </div>

        {/* Email */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Email</label>
          <input
            type="email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            className="w-full border rounded px-3 py-2 text-sm"
          />
          {emailError && <p className="text-vietnam-primary text-xs mt-1">{emailError}</p>}
        </div>

        {/* Phone */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Số điện thoại</label>
          <input
            type="text"
            value={userData.phone || ""}
            disabled
            className="w-full border rounded px-3 py-2 text-sm bg-gray-100"
          />
        </div>

        {/* Save button */}
        <button
          onClick={handleSave}
          disabled={loading}
          className="w-full bg-vietnam-primary text-white py-2 rounded hover:bg-vietnam-dark transition"
        >
          {loading ? "Đang lưu..." : "Lưu thông tin"}
        </button>
      </div>
    </div>
  );
}
